<template>
  <div>
    //
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  mounted() {
    this.logoutUser();
    this.$router.push({name: 'system@login'})
  },
  methods: {
    ...mapActions("userStore", ["logoutUser"]),
  }
};
</script>

<style></style>
